import { S as F, $ as T, g as z } from "./core.chunk.js";
function D(a, p, t, f) {
  const r = z();
  return (
    a.params.createElements &&
      Object.keys(f).forEach((c) => {
        if (!t[c] && t.auto === !0) {
          let i = a.$el.children(`.${f[c]}`)[0];
          i ||
            ((i = r.createElement("div")),
            (i.className = f[c]),
            a.$el.append(i)),
            (t[c] = i),
            (p[c] = i);
        }
      }),
    t
  );
}
function q({ swiper: a, extendParams: p, on: t, emit: f }) {
  p({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled",
    },
  }),
    (a.navigation = {
      nextEl: null,
      $nextEl: null,
      prevEl: null,
      $prevEl: null,
    });
  function r(n) {
    let s;
    return (
      n &&
        ((s = T(n)),
        a.params.uniqueNavElements &&
          typeof n == "string" &&
          s.length > 1 &&
          a.$el.find(n).length === 1 &&
          (s = a.$el.find(n))),
      s
    );
  }
  function c(n, s) {
    const e = a.params.navigation;
    n &&
      n.length > 0 &&
      (n[s ? "addClass" : "removeClass"](e.disabledClass),
      n[0] && n[0].tagName === "BUTTON" && (n[0].disabled = s),
      a.params.watchOverflow &&
        a.enabled &&
        n[a.isLocked ? "addClass" : "removeClass"](e.lockClass));
  }
  function i() {
    if (a.params.loop) return;
    const { $nextEl: n, $prevEl: s } = a.navigation;
    c(s, a.isBeginning && !a.params.rewind), c(n, a.isEnd && !a.params.rewind);
  }
  function b(n) {
    n.preventDefault(),
      !(a.isBeginning && !a.params.loop && !a.params.rewind) &&
        (a.slidePrev(), f("navigationPrev"));
  }
  function m(n) {
    n.preventDefault(),
      !(a.isEnd && !a.params.loop && !a.params.rewind) &&
        (a.slideNext(), f("navigationNext"));
  }
  function C() {
    const n = a.params.navigation;
    if (
      ((a.params.navigation = D(
        a,
        a.originalParams.navigation,
        a.params.navigation,
        { nextEl: "swiper-button-next", prevEl: "swiper-button-prev" }
      )),
      !(n.nextEl || n.prevEl))
    )
      return;
    const s = r(n.nextEl),
      e = r(n.prevEl);
    s && s.length > 0 && s.on("click", m),
      e && e.length > 0 && e.on("click", b),
      Object.assign(a.navigation, {
        $nextEl: s,
        nextEl: s && s[0],
        $prevEl: e,
        prevEl: e && e[0],
      }),
      a.enabled || (s && s.addClass(n.lockClass), e && e.addClass(n.lockClass));
  }
  function u() {
    const { $nextEl: n, $prevEl: s } = a.navigation;
    n &&
      n.length &&
      (n.off("click", m), n.removeClass(a.params.navigation.disabledClass)),
      s &&
        s.length &&
        (s.off("click", b), s.removeClass(a.params.navigation.disabledClass));
  }
  t("init", () => {
    a.params.navigation.enabled === !1 ? $() : (C(), i());
  }),
    t("toEdge fromEdge lock unlock", () => {
      i();
    }),
    t("destroy", () => {
      u();
    }),
    t("enable disable", () => {
      const { $nextEl: n, $prevEl: s } = a.navigation;
      n &&
        n[a.enabled ? "removeClass" : "addClass"](
          a.params.navigation.lockClass
        ),
        s &&
          s[a.enabled ? "removeClass" : "addClass"](
            a.params.navigation.lockClass
          );
    }),
    t("click", (n, s) => {
      const { $nextEl: e, $prevEl: l } = a.navigation,
        g = s.target;
      if (a.params.navigation.hideOnClick && !T(g).is(l) && !T(g).is(e)) {
        if (
          a.pagination &&
          a.params.pagination &&
          a.params.pagination.clickable &&
          (a.pagination.el === g || a.pagination.el.contains(g))
        )
          return;
        let o;
        e
          ? (o = e.hasClass(a.params.navigation.hiddenClass))
          : l && (o = l.hasClass(a.params.navigation.hiddenClass)),
          f(o === !0 ? "navigationShow" : "navigationHide"),
          e && e.toggleClass(a.params.navigation.hiddenClass),
          l && l.toggleClass(a.params.navigation.hiddenClass);
      }
    });
  const h = () => {
      a.$el.removeClass(a.params.navigation.navigationDisabledClass), C(), i();
    },
    $ = () => {
      a.$el.addClass(a.params.navigation.navigationDisabledClass), u();
    };
  Object.assign(a.navigation, {
    enable: h,
    disable: $,
    update: i,
    init: C,
    destroy: u,
  });
}
function P(a = "") {
  return `.${a
    .trim()
    .replace(/([\.:!\/])/g, "\\$1")
    .replace(/ /g, ".")}`;
}
function H({ swiper: a, extendParams: p, on: t, emit: f }) {
  const r = "swiper-pagination";
  p({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (e) => e,
      formatFractionTotal: (e) => e,
      bulletClass: `${r}-bullet`,
      bulletActiveClass: `${r}-bullet-active`,
      modifierClass: `${r}-`,
      currentClass: `${r}-current`,
      totalClass: `${r}-total`,
      hiddenClass: `${r}-hidden`,
      progressbarFillClass: `${r}-progressbar-fill`,
      progressbarOppositeClass: `${r}-progressbar-opposite`,
      clickableClass: `${r}-clickable`,
      lockClass: `${r}-lock`,
      horizontalClass: `${r}-horizontal`,
      verticalClass: `${r}-vertical`,
      paginationDisabledClass: `${r}-disabled`,
    },
  }),
    (a.pagination = { el: null, $el: null, bullets: [] });
  let c,
    i = 0;
  function b() {
    return (
      !a.params.pagination.el ||
      !a.pagination.el ||
      !a.pagination.$el ||
      a.pagination.$el.length === 0
    );
  }
  function m(e, l) {
    const { bulletActiveClass: g } = a.params.pagination;
    e[l]().addClass(`${g}-${l}`)[l]().addClass(`${g}-${l}-${l}`);
  }
  function C() {
    const e = a.rtl,
      l = a.params.pagination;
    if (b()) return;
    const g =
        a.virtual && a.params.virtual.enabled
          ? a.virtual.slides.length
          : a.slides.length,
      o = a.pagination.$el;
    let d;
    const E = a.params.loop
      ? Math.ceil((g - a.loopedSlides * 2) / a.params.slidesPerGroup)
      : a.snapGrid.length;
    if (
      (a.params.loop
        ? ((d = Math.ceil(
            (a.activeIndex - a.loopedSlides) / a.params.slidesPerGroup
          )),
          d > g - 1 - a.loopedSlides * 2 && (d -= g - a.loopedSlides * 2),
          d > E - 1 && (d -= E),
          d < 0 && a.params.paginationType !== "bullets" && (d = E + d))
        : typeof a.snapIndex < "u"
        ? (d = a.snapIndex)
        : (d = a.activeIndex || 0),
      l.type === "bullets" &&
        a.pagination.bullets &&
        a.pagination.bullets.length > 0)
    ) {
      const v = a.pagination.bullets;
      let x, k, S;
      if (
        (l.dynamicBullets &&
          ((c = v.eq(0)[a.isHorizontal() ? "outerWidth" : "outerHeight"](!0)),
          o.css(
            a.isHorizontal() ? "width" : "height",
            `${c * (l.dynamicMainBullets + 4)}px`
          ),
          l.dynamicMainBullets > 1 &&
            a.previousIndex !== void 0 &&
            ((i += d - (a.previousIndex - a.loopedSlides || 0)),
            i > l.dynamicMainBullets - 1
              ? (i = l.dynamicMainBullets - 1)
              : i < 0 && (i = 0)),
          (x = Math.max(d - i, 0)),
          (k = x + (Math.min(v.length, l.dynamicMainBullets) - 1)),
          (S = (k + x) / 2)),
        v.removeClass(
          ["", "-next", "-next-next", "-prev", "-prev-prev", "-main"]
            .map((M) => `${l.bulletActiveClass}${M}`)
            .join(" ")
        ),
        o.length > 1)
      )
        v.each((M) => {
          const B = T(M),
            y = B.index();
          y === d && B.addClass(l.bulletActiveClass),
            l.dynamicBullets &&
              (y >= x && y <= k && B.addClass(`${l.bulletActiveClass}-main`),
              y === x && m(B, "prev"),
              y === k && m(B, "next"));
        });
      else {
        const M = v.eq(d),
          B = M.index();
        if ((M.addClass(l.bulletActiveClass), l.dynamicBullets)) {
          const y = v.eq(x),
            I = v.eq(k);
          for (let O = x; O <= k; O += 1)
            v.eq(O).addClass(`${l.bulletActiveClass}-main`);
          if (a.params.loop)
            if (B >= v.length) {
              for (let O = l.dynamicMainBullets; O >= 0; O -= 1)
                v.eq(v.length - O).addClass(`${l.bulletActiveClass}-main`);
              v.eq(v.length - l.dynamicMainBullets - 1).addClass(
                `${l.bulletActiveClass}-prev`
              );
            } else m(y, "prev"), m(I, "next");
          else m(y, "prev"), m(I, "next");
        }
      }
      if (l.dynamicBullets) {
        const M = Math.min(v.length, l.dynamicMainBullets + 4),
          B = (c * M - c) / 2 - S * c,
          y = e ? "right" : "left";
        v.css(a.isHorizontal() ? y : "top", `${B}px`);
      }
    }
    if (
      (l.type === "fraction" &&
        (o.find(P(l.currentClass)).text(l.formatFractionCurrent(d + 1)),
        o.find(P(l.totalClass)).text(l.formatFractionTotal(E))),
      l.type === "progressbar")
    ) {
      let v;
      l.progressbarOpposite
        ? (v = a.isHorizontal() ? "vertical" : "horizontal")
        : (v = a.isHorizontal() ? "horizontal" : "vertical");
      const x = (d + 1) / E;
      let k = 1,
        S = 1;
      v === "horizontal" ? (k = x) : (S = x),
        o
          .find(P(l.progressbarFillClass))
          .transform(`translate3d(0,0,0) scaleX(${k}) scaleY(${S})`)
          .transition(a.params.speed);
    }
    l.type === "custom" && l.renderCustom
      ? (o.html(l.renderCustom(a, d + 1, E)), f("paginationRender", o[0]))
      : f("paginationUpdate", o[0]),
      a.params.watchOverflow &&
        a.enabled &&
        o[a.isLocked ? "addClass" : "removeClass"](l.lockClass);
  }
  function u() {
    const e = a.params.pagination;
    if (b()) return;
    const l =
        a.virtual && a.params.virtual.enabled
          ? a.virtual.slides.length
          : a.slides.length,
      g = a.pagination.$el;
    let o = "";
    if (e.type === "bullets") {
      let d = a.params.loop
        ? Math.ceil((l - a.loopedSlides * 2) / a.params.slidesPerGroup)
        : a.snapGrid.length;
      a.params.freeMode &&
        a.params.freeMode.enabled &&
        !a.params.loop &&
        d > l &&
        (d = l);
      for (let E = 0; E < d; E += 1)
        e.renderBullet
          ? (o += e.renderBullet.call(a, E, e.bulletClass))
          : (o += `<${e.bulletElement} class="${e.bulletClass}"></${e.bulletElement}>`);
      g.html(o), (a.pagination.bullets = g.find(P(e.bulletClass)));
    }
    e.type === "fraction" &&
      (e.renderFraction
        ? (o = e.renderFraction.call(a, e.currentClass, e.totalClass))
        : (o = `<span class="${e.currentClass}"></span> / <span class="${e.totalClass}"></span>`),
      g.html(o)),
      e.type === "progressbar" &&
        (e.renderProgressbar
          ? (o = e.renderProgressbar.call(a, e.progressbarFillClass))
          : (o = `<span class="${e.progressbarFillClass}"></span>`),
        g.html(o)),
      e.type !== "custom" && f("paginationRender", a.pagination.$el[0]);
  }
  function h() {
    a.params.pagination = D(
      a,
      a.originalParams.pagination,
      a.params.pagination,
      { el: "swiper-pagination" }
    );
    const e = a.params.pagination;
    if (!e.el) return;
    let l = T(e.el);
    l.length !== 0 &&
      (a.params.uniqueNavElements &&
        typeof e.el == "string" &&
        l.length > 1 &&
        ((l = a.$el.find(e.el)),
        l.length > 1 &&
          (l = l.filter((g) => T(g).parents(".swiper")[0] === a.el))),
      e.type === "bullets" && e.clickable && l.addClass(e.clickableClass),
      l.addClass(e.modifierClass + e.type),
      l.addClass(a.isHorizontal() ? e.horizontalClass : e.verticalClass),
      e.type === "bullets" &&
        e.dynamicBullets &&
        (l.addClass(`${e.modifierClass}${e.type}-dynamic`),
        (i = 0),
        e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)),
      e.type === "progressbar" &&
        e.progressbarOpposite &&
        l.addClass(e.progressbarOppositeClass),
      e.clickable &&
        l.on("click", P(e.bulletClass), function (o) {
          o.preventDefault();
          let d = T(this).index() * a.params.slidesPerGroup;
          a.params.loop && (d += a.loopedSlides), a.slideTo(d);
        }),
      Object.assign(a.pagination, { $el: l, el: l[0] }),
      a.enabled || l.addClass(e.lockClass));
  }
  function $() {
    const e = a.params.pagination;
    if (b()) return;
    const l = a.pagination.$el;
    l.removeClass(e.hiddenClass),
      l.removeClass(e.modifierClass + e.type),
      l.removeClass(a.isHorizontal() ? e.horizontalClass : e.verticalClass),
      a.pagination.bullets &&
        a.pagination.bullets.removeClass &&
        a.pagination.bullets.removeClass(e.bulletActiveClass),
      e.clickable && l.off("click", P(e.bulletClass));
  }
  t("init", () => {
    a.params.pagination.enabled === !1 ? s() : (h(), u(), C());
  }),
    t("activeIndexChange", () => {
      (a.params.loop || typeof a.snapIndex > "u") && C();
    }),
    t("snapIndexChange", () => {
      a.params.loop || C();
    }),
    t("slidesLengthChange", () => {
      a.params.loop && (u(), C());
    }),
    t("snapGridLengthChange", () => {
      a.params.loop || (u(), C());
    }),
    t("destroy", () => {
      $();
    }),
    t("enable disable", () => {
      const { $el: e } = a.pagination;
      e &&
        e[a.enabled ? "removeClass" : "addClass"](
          a.params.pagination.lockClass
        );
    }),
    t("lock unlock", () => {
      C();
    }),
    t("click", (e, l) => {
      const g = l.target,
        { $el: o } = a.pagination;
      if (
        a.params.pagination.el &&
        a.params.pagination.hideOnClick &&
        o &&
        o.length > 0 &&
        !T(g).hasClass(a.params.pagination.bulletClass)
      ) {
        if (
          a.navigation &&
          ((a.navigation.nextEl && g === a.navigation.nextEl) ||
            (a.navigation.prevEl && g === a.navigation.prevEl))
        )
          return;
        const d = o.hasClass(a.params.pagination.hiddenClass);
        f(d === !0 ? "paginationShow" : "paginationHide"),
          o.toggleClass(a.params.pagination.hiddenClass);
      }
    });
  const n = () => {
      a.$el.removeClass(a.params.pagination.paginationDisabledClass),
        a.pagination.$el &&
          a.pagination.$el.removeClass(
            a.params.pagination.paginationDisabledClass
          ),
        h(),
        u(),
        C();
    },
    s = () => {
      a.$el.addClass(a.params.pagination.paginationDisabledClass),
        a.pagination.$el &&
          a.pagination.$el.addClass(
            a.params.pagination.paginationDisabledClass
          ),
        $();
    };
  Object.assign(a.pagination, {
    enable: n,
    disable: s,
    render: u,
    update: C,
    init: h,
    destroy: $,
  });
}
function N(a) {
  const {
    effect: p,
    swiper: t,
    on: f,
    setTranslate: r,
    setTransition: c,
    overwriteParams: i,
    perspective: b,
    recreateShadows: m,
    getEffectParams: C,
  } = a;
  f("beforeInit", () => {
    if (t.params.effect !== p) return;
    t.classNames.push(`${t.params.containerModifierClass}${p}`),
      b && b() && t.classNames.push(`${t.params.containerModifierClass}3d`);
    const h = i ? i() : {};
    Object.assign(t.params, h), Object.assign(t.originalParams, h);
  }),
    f("setTranslate", () => {
      t.params.effect === p && r();
    }),
    f("setTransition", (h, $) => {
      t.params.effect === p && c($);
    }),
    f("transitionEnd", () => {
      if (t.params.effect === p && m) {
        if (!C || !C().slideShadows) return;
        t.slides.each((h) => {
          t.$(h)
            .find(
              ".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left"
            )
            .remove();
        }),
          m();
      }
    });
  let u;
  f("virtualUpdate", () => {
    t.params.effect === p &&
      (t.slides.length || (u = !0),
      requestAnimationFrame(() => {
        u && t.slides && t.slides.length && (r(), (u = !1));
      }));
  });
}
function A(a, p) {
  return a.transformEl
    ? p
        .find(a.transformEl)
        .css({
          "backface-visibility": "hidden",
          "-webkit-backface-visibility": "hidden",
        })
    : p;
}
function L({ swiper: a, duration: p, transformEl: t, allSlides: f }) {
  const { slides: r, activeIndex: c, $wrapperEl: i } = a;
  if (a.params.virtualTranslate && p !== 0) {
    let b = !1,
      m;
    f ? (m = t ? r.find(t) : r) : (m = t ? r.eq(c).find(t) : r.eq(c)),
      m.transitionEnd(() => {
        if (b || !a || a.destroyed) return;
        (b = !0), (a.animating = !1);
        const C = ["webkitTransitionEnd", "transitionend"];
        for (let u = 0; u < C.length; u += 1) i.trigger(C[u]);
      });
  }
}
function j({ swiper: a, extendParams: p, on: t }) {
  p({ fadeEffect: { crossFade: !1, transformEl: null } }),
    N({
      effect: "fade",
      swiper: a,
      on: t,
      setTranslate: () => {
        const { slides: c } = a,
          i = a.params.fadeEffect;
        for (let b = 0; b < c.length; b += 1) {
          const m = a.slides.eq(b);
          let u = -m[0].swiperSlideOffset;
          a.params.virtualTranslate || (u -= a.translate);
          let h = 0;
          a.isHorizontal() || ((h = u), (u = 0));
          const $ = a.params.fadeEffect.crossFade
            ? Math.max(1 - Math.abs(m[0].progress), 0)
            : 1 + Math.min(Math.max(m[0].progress, -1), 0);
          A(i, m)
            .css({ opacity: $ })
            .transform(`translate3d(${u}px, ${h}px, 0px)`);
        }
      },
      setTransition: (c) => {
        const { transformEl: i } = a.params.fadeEffect;
        (i ? a.slides.find(i) : a.slides).transition(c),
          L({ swiper: a, duration: c, transformEl: i, allSlides: !0 });
      },
      overwriteParams: () => ({
        slidesPerView: 1,
        slidesPerGroup: 1,
        watchSlidesProgress: !0,
        spaceBetween: 0,
        virtualTranslate: !a.params.cssMode,
      }),
    });
}
class G extends HTMLElement {
  constructor() {
    super(), (this.swiper = this.querySelector("[best-reviews-swiper]"));
  }
  connectedCallback() {
    new F(`#${this.swiper.id}`, {
      modules: [q, j, H],
      navigation: {
        nextEl: ".swiper-button-next.reviews-next",
        prevEl: ".swiper-button-prev.reviews-prev",
      },
      pagination: {
        el: `#${this.swiper.id} .swiper-pagination`,
        clickable: !0,
      },
      slidesPerView: 1,
      spaceBetween: 16,
      loop: !0,
      effect: "fade",
      fadeEffect: { crossFade: !0 },
    });
  }
}
customElements.define("reviews-swiper", G);
